import { render } from "./GenogramToolMain.vue?vue&type=template&id=9cdf8008"
import script from "./GenogramToolMain.vue?vue&type=script&lang=js"
export * from "./GenogramToolMain.vue?vue&type=script&lang=js"

import "./GenogramToolMain.vue?vue&type=style&index=0&id=9cdf8008&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__